export interface ChessQuote {
  text: string;
  author: string;
}

export const CHESS_QUOTES: ChessQuote[] = [
  {
    text: "Chess is a war over the board. The object is to crush the opponent's mind.",
    author: 'Bobby Fischer',
  },
  {
    text: 'The beauty of chess is it can be whatever you want it to be. It transcends language, age, race, religion, politics, gender and socioeconomic background.',
    author: 'Maurice Ashley',
  },
  {
    text: 'Chess is life in miniature. Chess is struggle, chess is battles.',
    author: 'Garry Kasparov',
  },
  {
    text: 'In chess, knowledge is a very transient thing. It changes so fast that even a single mouse-slip sometimes changes the evaluation.',
    author: 'Vladimir Kramnik',
  },
  {
    text: 'Chess is the art of analysis.',
    author: 'Mikhail Botvinnik',
  },
  {
    text: 'The game of chess is not merely an idle amusement. Several very valuable qualities of the mind are to be acquired and strengthened by it.',
    author: 'Benjamin Franklin',
  },
  {
    text: 'Chess is the struggle against error.',
    author: 'Johannes Zukertort',
  },
  {
    text: 'Chess is a game of understanding, not memory.',
    author: 'Viktor Korchnoi',
  },
  {
    text: 'The most powerful weapon in chess is to have the next move.',
    author: 'David Bronstein',
  },
  {
    text: 'Chess is mental torture.',
    author: 'Garry Kasparov',
  },
];
